import { AxiosResponse } from 'axios';
import ListWithTotal from 'common/dto-types/list-with-total-dto';
import TeamDto from 'common/dto-types/team-dto';
import axiosServices, { PaginationAndFiltersParams, buildQueryParams } from 'utils/axios';

export const TEAMS_API_URL = '/teams';

export const createTeam = async (team: TeamDto): Promise<number | null | undefined> => {
    try {
        return await axiosServices.post(TEAMS_API_URL, team).then((res) => res.data);
    } catch (err) {
        console.error(err);
        return null;
    }
};

export const deleteTeam = async (id: string): Promise<number | null> => {
    try {
        return await axiosServices.delete(`${TEAMS_API_URL}/${id}`).then((res) => res.status);
    } catch (err) {
        console.error(err);
        return null;
    }
};

export const fetchTeamList = async (
    params: PaginationAndFiltersParams,
): Promise<ListWithTotal<TeamDto> | null | undefined> => {
    try {
        const res = await axiosServices.get(`${TEAMS_API_URL}${buildQueryParams(params)}`);
        return res.data;
    } catch (err) {
        // TODO: Implement a proper way to handle errors
        // https://fifadigital.atlassian.net/browse/FMH-2075
        console.error(err);
        return null;
    }
};

export const synchronizeFdcpTeams = async (tournamentFdcpId: string): Promise<AxiosResponse | null | undefined> => {
    try {
        return await axiosServices.post(`${TEAMS_API_URL}/syncFdcpTeams/${tournamentFdcpId}`);
    } catch (err) {
        const errorResponse = err as AxiosResponse;
        if (errorResponse) return errorResponse;
        return null;
    }
};
